import { z } from "zod";

const DOMAIN_TO_IDP: Record<string, string> = {
  "alaffia.io": "alaffia-gsuite",
  "alaffiahealth.com": "alaffia-gsuite",
};

type DiscoveryResult =
  | {
      status: "found";
      identityProvider: string;
      domain: string;
    }
  | {
      status: "not-found";
      domain: string | null;
    };

export const emailSchema = z.string().trim().email();

export const isValidEmailSyntax = (value: string): boolean =>
  emailSchema.safeParse(value).success;

const getEmailDomain = (value: string): string | null => {
  const parsed = emailSchema.safeParse(value);
  if (!parsed.success) return null;

  return parsed.data.slice(parsed.data.lastIndexOf("@") + 1).toLowerCase();
};

export const discoverIdpForEmail = (email: string): DiscoveryResult => {
  const domain = getEmailDomain(email);
  if (!domain) return { status: "not-found", domain: null };

  const identityProvider = DOMAIN_TO_IDP[domain];
  if (!identityProvider) return { status: "not-found", domain };

  return { status: "found", identityProvider, domain };
};
